import React from "react";
import AdvisorService from "../../Services/Advisor.service";
// Term for advisor is likely not to change, so we cache it here.
let termForAdvisor = null;
const useTermForAdvisor = () => {
    // Need to re-render when after we load in the term, so this needs to be stateful.
    const [statefulTerm, setStatefulTerm] = React.useState(termForAdvisor);
    React.useEffect(() => {
        if (!termForAdvisor) {
            AdvisorService.getTermForAdvisor().then((term) => {
                termForAdvisor = term;
                setStatefulTerm(term);
            });
        }
    }, []);
    return statefulTerm;
};
export default useTermForAdvisor;
